import React from 'react'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import WomanSadNotebook from '../../commons/Ilustrations/WomanSadNotebook'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'

const AwaitingApprovalContainer = () => {
  return (
    <ExternalLayout>
      <FeedbackLayout
        title="Sua conta está em análise"
        subTitle="O seu cadastro precisa ser aprovado para você realizar o login. Isso pode levar alguns dias. Aguarde um e-mail com maiores instruções."
        secondaryAction={() => history.push(routes.root.path)}
        secondaryLabelAction="OK"
        Ilustration={WomanSadNotebook}
        textAlign="left"
      />
    </ExternalLayout>
  )
}

export default AwaitingApprovalContainer
